.header {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  padding: 1.25rem 0;
  transition: all 0.3s ease;
}
.header--scrolled {
  background: rgba(13,13,13,0.95);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid var(--dark-border);
  padding: 0.7rem 0;
}
.header__container {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header__logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--font-serif);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gold);
  text-decoration: none;
  letter-spacing: 0.02em;
}
.header__logo-icon { font-size: 1.2rem; color: var(--gold-bright); }

.header__nav { display: flex; align-items: center; gap: 2rem; }
.header__nav-link {
  color: var(--text-sec);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  transition: color 0.2s;
}
.header__nav-link:hover { color: var(--gold); }
.header__nav-link--cta {
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  color: #000 !important;
  padding: 0.4rem 1rem;
  border-radius: var(--radius);
  font-weight: 600;
}
.header__nav-link--cta:hover { filter: brightness(1.1); }

.header__hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}
.header__hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  background: var(--text-primary);
  border-radius: 2px;
  transition: all 0.25s ease;
}
.header__hamburger--open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
.header__hamburger--open span:nth-child(2) { opacity: 0; }
.header__hamburger--open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

@media (max-width: 768px) {
  .header__hamburger { display: flex; }
  .header__nav {
    display: none;
    position: absolute;
    top: 100%; left: 0; right: 0;
    background: var(--dark-surface);
    flex-direction: column;
    align-items: flex-start;
    padding: 1.5rem;
    gap: 1.25rem;
    border-bottom: 1px solid var(--dark-border);
  }
  .header__nav--open { display: flex; }
}
